import { render, staticRenderFns } from "./TasksUsuarioStats.vue?vue&type=template&id=b966a0fc&"
import script from "./TasksUsuarioStats.vue?vue&type=script&lang=js&"
export * from "./TasksUsuarioStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports